import React from "react";
import { FormattedMessage } from "react-intl";

const PassportVerificationGuidelines: React.FC = () => {
  return (
    <div>
      <ul>
        <li>
          <FormattedMessage
            id="account-verification-guidelines-full-name"
            defaultMessage="Matches the full name you provided."
          />
        </li>
        <li>
          <FormattedMessage
            id="account-verification-guidelines-date-of-birth"
            defaultMessage="Matches your date of birth."
          />
        </li>
        <li>
          <FormattedMessage
            id="account-verification-guidelines-valid"
            defaultMessage="Hasn't expired and is still valid for use."
          />
        </li>
      </ul>
    </div>
  );
};

export default PassportVerificationGuidelines;
